export default __webpack_public_path__ + "static/media/9.2f742e7d.png";